import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { InfiniteResult } from '../_models/body';

@Injectable({
  providedIn: 'root'
})
export class LlmSettingService {
  constructor(
    private httpClient: HttpClient
  ) { }

  getLlmSettings(params) {
    return this.httpClient.get<InfiniteResult>(`${environment.apiEndpoint}api/LlmSetting/Query`, {
      params: params
    })
  }

  getLlmSettingById(id) {
    return this.httpClient.get(`${environment.apiEndpoint}api/LlmSetting/${id}`)
  }

  deleteLlmSetting(id) {
    return this.httpClient.delete(`${environment.apiEndpoint}api/LlmSetting/${id}`)
  }

  createLlmSetting(data) {
    return this.httpClient.post(`${environment.apiEndpoint}api/LlmSetting`, data)
  }

  updateLlmSetting(data, id) {
    return this.httpClient.put(`${environment.apiEndpoint}api/LlmSetting/${id}`, data)
  }

  setLlmSettingActived(id) {
    return this.httpClient.put(`${environment.apiEndpoint}api/LlmSetting/${id}/SetActived`, null)
  }

   getLlmModels(params?: any) {
    return this.httpClient.get(`${environment.apiEndpoint}api/LlmSetting/Models`, {
      params: params
    })
  }
}
